module.exports = __webpack_public_path__ + "static/media/5C1A8E.f290aa77.svg";